import { META, HOURS } from './data';
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#0A2E3C] text-[#F8FAFB] mt-20">
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-14 grid md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif text-3xl">{META.brand}</p>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#7DC3D1] mt-2">{META.tag}</p>
          <p className="text-sm text-[#F8FAFB]/65 mt-5 leading-[1.7] max-w-md">A small dental practice in Marylebone. Three dentists. One hygienist. Six-month re-call. Insurance-friendly · Bupa, AXA, Vitality, WPA.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#E08672] mb-3">Practice</p>
          <p className="text-sm text-[#F8FAFB]/85 leading-relaxed">14 Welbeck Street<br />Marylebone, London W1G 8DX</p>
          <p className="font-mono text-[11px] text-[#F8FAFB]/55 mt-3">+44 20 7935 0184</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#E08672] mb-3">Hours</p>
          <table className="w-full text-xs"><tbody>{HOURS.map(([d, h]) => (<tr key={d}><td className="py-1 text-[#F8FAFB]/55">{d}</td><td className="py-1 text-right font-mono text-[10px]">{h}</td></tr>))}</tbody></table>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#E08672] mb-3">Insurance</p>
          <ul className="text-sm text-[#F8FAFB]/85 space-y-1"><li>Bupa</li><li>AXA · PPP</li><li>Vitality</li><li>WPA</li></ul>
        </div>
      </div>
      <div className="border-t border-[#F8FAFB]/15 px-8 lg:px-14 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#F8FAFB]/40">
        <span>© 2026 {META.brand} Practice · GDC-registered · CQC-rated Outstanding</span>
        <div className="flex gap-6"><button onClick={() => setPage('team')} className="hover:text-[#E08672]">Doctors</button><a href="#" className="hover:text-[#E08672]">Privacy</a></div>
      </div>
    </footer>
  );
}
